import { Actions } from '../actions/Actions';

const dashboardReducer = (state: any = {}, action: any) => {
  switch (action.type) {
    case Actions.GET_STATES:
      return {
        ...state,
        workItem_states: action.payload,
      };
    case Actions.GET_AREAS:
      return {
        ...state,
        areas: action.payload,
      };
    case Actions.SET_VIEWS:
      return {
        ...state,
        views: action.payload,
      };
    case Actions.GET_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case Actions.GET_USER_PROFILE:
      return {
        ...state,
        user_profile: action.payload,
      };
    case Actions.SET_TEAM:
      return {
        ...state,
        user_team: action.payload,
      };
    case Actions.SET_DASHBOARD_SPLIT_MODE:
      return {
        ...state,
        dashboardSplitMode: action.payload,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
